import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { TestimonialCarousel } from '@bepure/tarkin';

interface Testimonial {
    imageUrl: string;
    quote: string;
    author?: string;
}

interface Props {
    title?: string;
    testimonials: Testimonial[];
    button?: {
        text: string;
        link: string;
        // onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
    };
}

class TestimonialCarouselSection extends React.Component<Props> {
    public render() {
        const usedButton = this.props.button ? {
                text: this.props.button.text,
                onClick: this.handleCallToAction(this.props.button.link),
        } : undefined;
        return (
            <TestimonialCarousel
               title={this.props.title}
               testimonials={this.props.testimonials}
               button={usedButton}
            />
        );
    }

    private handleCallToAction = (link: string) => {
        return (() => {
            if (link) {
                window.location.href = link;
            }
        });
    }
}

export default function render() {
    const elements = document.getElementsByClassName('testimonial-carousel-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const title = element.dataset.title ? element.dataset.title : null;
        const children = Array.prototype.slice.call(element.children);
        const testimonials = children.filter((child: HTMLElement) => child.dataset.imageurl).map((child: HTMLElement) => {
            const returnValue = {
                imageUrl: child.dataset.imageurl || '',
                quote: `“${child.dataset.testquote}”` || '',
                author: child.dataset.testauthor || '',
            };
            return returnValue;
        });
        const button = {
            text: element.dataset.buttontext ? element.dataset.buttontext : '',
            link: element.dataset.buttonlink ? element.dataset.buttonlink : '',
        };

        if (testimonials.length > 0) {
            return ReactDOM.render(
                <TestimonialCarouselSection
                    {...(title ? {title} : {})}
                    testimonials={testimonials}
                    {...((button && button.link && button.text) ? {button} : {})}
                />,
                element,
            );
        }
    });
}
